export const environment = {
  production: false,
  name: 'dev',
  // apiUrl: 'http://127.0.0.1:8501',
  apiUrl: 'https://wf40.datacompute.org/b0aea927197b',
  sessionStorage: false,
};
